<div
  class="content-card small-card"
  tabindex="0"
  [class.disabled]="!data.active"
  [ngClass]="'bundle-' + data.bundle"
  [attr.data-cy]="data.bundle + '-card-' + data.id"
  (click)="cardClick.emit($event)">
  <div class="content-card__media">
    <div
      class="content-card__media--image"
      [placeholderImage]="!data?.mediaImage && data.bundle"
      [cropImage]="(data?.mediaImage | preSignedUrl | async) || data.image"
      [crop]="data.mediaImage?.crop"
      imageWidth="200">
    </div>
  </div>
  <div class="content-card__body">
    <div class="content-card__body--title">{{data.title}}</div>
    @if (!data.progress || data.progress !== 100) {
      @if (data.progress && !hideProgress) {
        <div class="content-card__body--footer-item progress-indicator">
          <mat-progress-bar class="default-theme" aria-label="Progress" mode="determinate" [value]="data.progress" data-cy="card-progress-bar"></mat-progress-bar> {{data.progress}}%
        </div>
      }
    } @else {
      <div class="content-card__body--footer-item completed-indicator">
        <lib-icon icon="check-circle" [fill]="true"></lib-icon> {{'MODULE_LESSON_CARD.completed' | translate}}
      </div>
    }
  </div>

</div>

